import { render } from "./slideout-navigation.vue?vue&type=template&id=3ab464cd"
import script from "./slideout-navigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./slideout-navigation.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3ab464cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ab464cd', script)) {
    api.reload('3ab464cd', script)
  }
  
  module.hot.accept("./slideout-navigation.vue?vue&type=template&id=3ab464cd", () => {
    api.rerender('3ab464cd', render)
  })

}

script.__file = "resources/ts/components/elements/slideout-navigation.vue"

export default script